import React, { Suspense } from 'react';

const UKPoliciesLazy = React.lazy(() => import("./Policies/UKPolicies"));
const GermanyPoliciesLazy = React.lazy(() => import("./Policies/GermanyPolicies"));
const EUPoliciesLazy = React.lazy(() => import("./Policies/EUPolicies"));
const USAPoliciesLazy = React.lazy(() => import("./Policies/USAPolicies"));

export const ukData = {
  keyName: "uk",
  graphicSource: "https://drive.google.com/file/d/1szAQ6bnoIVwic9_yXgSbAT7ejY_TSNeI/view", // TODO
  policyComponent: (
    <Suspense fallback={<div>Loading...</div>}>
      <UKPoliciesLazy />
    </Suspense>
  )
};
export const germanyData = {
  keyName: "germany",
  graphicSource: "https://drive.google.com/file/d/1tib0ImZFGpYP9No7qctbAKTqKZLF3ytd/view",// TODO
  policyComponent: (
    <Suspense fallback={<div>Loading...</div>}>
      <GermanyPoliciesLazy />
    </Suspense>
  )
};
export const euData = {
  keyName: "eu",
  graphicSource: "https://drive.google.com/file/d/1H7Wa4IHzqIEX_jz2ZviIYWbhqMwQcoWP/view",// TODO
  policyComponent: (
    <Suspense fallback={<div>Loading...</div>}>
      <EUPoliciesLazy />
    </Suspense>
  )
};
export const usaData = {
  keyName: "usa",
  graphicSource: "https://drive.google.com/file/d/16mUFtamCGq38HoCDtzeRY9U6P7GuP6BA/view",// TODO
  policyComponent: (
    <Suspense fallback={<div>Loading...</div>}>
      <USAPoliciesLazy />
    </Suspense>
  )
};
